
import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Shipment, ShipmentLine, IShipment, PorterListViewModel } from 'Api/CoreApi';
import ApiProvider from 'Api/ApiProvider';
import { Dictionary } from 'vuex';
import { groupBy } from "lodash-es";

@Component({})
export class ShipmentDetailsComponent extends ABaseComponent {
    @Prop()
    shipmentNumber: string;
    shipment: IShipment = {};
    shipmentLinesByPorter: Dictionary<ShipmentLine[]> = {};

    model: PorterListViewModel | null = null;

    @Prop({ default: 'LANG1' })
    languageId: string;

    GetName(porterNo:string) : string {
        if (!this.model) return porterNo;
        let val = this.model.porters.find(p => p.contactNo === porterNo);
        if (!val) return porterNo;
        return porterNo + " - " + val.firstName + " " + val.lastName; 
    }

    async created() {
        try {
            let client = ApiProvider.getApiClient();
            this.model = await client.getPorterListForShipping(); 
            let shipments = await client.getShipments(this.shipmentNumber, this.languageId);
            this.shipment = shipments[0];

            let shipmentLines = await client.getShipmentLines(this.shipmentNumber);

            this.shipmentLinesByPorter = groupBy(
                shipmentLines
                , (item) => {
                    return item.porterNumber;
                }
            );

           

            this.setLoaded();
        } catch (e) {
            this.setError(e);
        }
    }
}
Vue.component('shipment-details', ShipmentDetailsComponent);